import { createContext } from 'react'

import { UserLogDto } from '../../../lib/graphql'

export interface ILogsContext {
  createUserLog: (userLogDto: UserLogDto) => Promise<void>
  parentLogId: string | undefined
  setParentLog: (parentId: string | undefined) => void
}

export const LogsContext = createContext({} as ILogsContext)
